module.exports = __webpack_public_path__ + "static/testimonial_person_2-007cb6f5a002c8fb5cb8d0fd8dc2c7d0.jpg";